import { AutogenModelJobClassCodeLookup, AutogenRowJobClassCodeLookup } from "./autogen/AutogenModelJobClassCodeLookup";

export class ModelJobClassCodeLookup extends AutogenModelJobClassCodeLookup<RowJobClassCodeLookup> {
	constructor() {
		super(RowJobClassCodeLookup);
	}
}

export class RowJobClassCodeLookup extends AutogenRowJobClassCodeLookup {
}